import { render } from "./Sidebar.vue?vue&type=template&id=4aa9e75d&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "@/assets/scss/_sidebar.scss?vue&type=style&index=0&id=4aa9e75d&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aa9e75d"]])

export default __exports__